// Display helpers for MCP clients and scopes (Connected agents page, and the
// MCP badge in a talk track's history).

// The CIMD documents of the clients we know, by URL.
const KNOWN_CLIENTS: Record<string, string> = {
  "https://claude.ai/oauth/claude-code-client-metadata": "Claude Code",
  "https://claude.ai/oauth/mcp-oauth-client-metadata": "Claude",
};

// A readable name for an MCP client: its stored name, a known CIMD URL, the
// URL's host, or the raw id (dev-registered clients, the dev token).
export function clientLabel(clientId: string | null | undefined, clientName?: string | null): string {
  if (clientName) return clientName;
  if (!clientId) return "MCP";
  if (KNOWN_CLIENTS[clientId]) return KNOWN_CLIENTS[clientId];
  try {
    const url = new URL(clientId);
    if (url.protocol === "https:") return url.hostname === "chatgpt.com" ? "ChatGPT" : url.hostname;
  } catch {
    /* not a URL */
  }
  return clientId;
}

export type ScopeLevel = "read" | "write" | "release";

export interface ScopeChip {
  scope: string;
  domain: string;
  level: string;
}

// Scopes as <domain>:<level> chips, release last (it's the one to notice).
const LEVEL_ORDER: Record<string, number> = { read: 0, write: 1, release: 2 };

export function scopeChips(scopes: string[]): ScopeChip[] {
  return scopes
    .map((scope) => {
      const [domain, level = ""] = scope.split(":", 2);
      return { scope, domain, level };
    })
    .sort(
      (a, b) =>
        (LEVEL_ORDER[a.level] ?? 3) - (LEVEL_ORDER[b.level] ?? 3) || a.domain.localeCompare(b.domain),
    );
}

export function holdsRelease(scopes: string[]): boolean {
  return scopes.some((s) => s.endsWith(":release"));
}
